import React from 'react';
import { CheckCircle, Circle, CalendarDays, User, Edit2, Trash2 } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { faelligkeitAnzeige } from '../../lib/faelligkeit';

export interface TaskItemProps {
  id: number;
  title: string;
  description?: string | null;
  dueAt: string;
  isDone: boolean;
  assignedUserId: number;
  createdByUserId: number;
  onToggleDone?: (id: number, next: boolean) => void;
  onEdit?: (id: number) => void;
  onDelete?: (id: number) => void;
}

export const TaskItem: React.FC<TaskItemProps> = ({ id, title, description, dueAt, isDone, assignedUserId, createdByUserId, onToggleDone, onEdit, onDelete }) => {
  const dueDate = new Date(dueAt);
  const isOverdue = !isDone && dueDate.getTime() < Date.now();
  const isToday = !isDone && new Date(dueDate.toDateString()).getTime() === new Date(new Date().toDateString()).getTime();

  return (
    <div className="flex items-start gap-3 rounded-lg border p-3">
      <button
        className="mt-0.5"
        aria-label={isDone ? 'Als offen markieren' : 'Als erledigt markieren'}
        onClick={() => onToggleDone?.(id, !isDone)}
      >
        {isDone ? <CheckCircle className="h-5 w-5 text-green-500" /> : <Circle className="h-5 w-5 text-blue-500" />}
      </button>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <div className={`font-medium ${isDone ? 'line-through text-muted-foreground' : ''}`}>{title}</div>
          <div className="flex items-center gap-2">
            <Badge variant="outline" className={`${isOverdue ? 'bg-red-50 text-red-700 border-red-200' : isToday ? 'bg-amber-50 text-amber-700 border-amber-200' : ''}`}>
              <CalendarDays className="mr-1 h-3.5 w-3.5" />
              {faelligkeitAnzeige(dueAt)}
            </Badge>
          </div>
        </div>
        {description && <div className="mt-1 text-sm text-muted-foreground whitespace-pre-wrap">{description}</div>}
        <div className="mt-1 flex items-center gap-3 text-xs text-muted-foreground">
          <span className="inline-flex items-center gap-1"><User className="h-3.5 w-3.5" /> Zugewiesen: #{assignedUserId}</span>
          <span className="inline-flex items-center gap-1">Erstellt von: #{createdByUserId}</span>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={() => onEdit?.(id)}>
          <Edit2 className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0 text-destructive" onClick={() => onDelete?.(id)}>
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default TaskItem;


